import React from 'react';
import FidanMarket from "../images/fidan-market.png";
import HorizonCinemas from "../images/horizon-cinemas.png";
import PlayersRUs from "../images/players-r-us.jpg";
import ProductCountApp from "../images/product-count-app.png";
import NHSPharmacy from "../images/nhs-pharmacy.png";
import UniHub from "../images/UniHub.png";
import UniHubLogin from "../images/UniHub_Login.png";
import StrawberryFarm from "../images/strawberry-farm.png";
import WilsonToolApp from "../images/wilsontool-app.jpeg";
import AppStoreIcon from "../images/app-store.svg";
import GooglePlayStoreIcon from "../images/google-playstore.svg";
import { FaGithub } from 'react-icons/fa';

const Projects: React.FC = () => {
    const projectList = [
        {
            title: 'Wilson Tool App',
            description: 'Cross-platform engineering application used by punch press and press brake operators to perform sheet metal calculations and tooling selection. Designed to standardise calculations, reduce manual errors, and give engineers quick access to production data.',
            frameworks: 'React Native, Node.js, TypeScript',
            image: WilsonToolApp,
            large: true,
            downloadLinks: {
                apple: 'https://apps.apple.com/gb/app/wilson-tool/id6472720282',
                android: 'https://play.google.com/store/apps/details?id=com.WilsonTool.WilsonOne&pcampaignid=web_share'
            }
        },
        {
            title: 'UniHub',
            description: 'Full-stack university community platform enabling students to discover events, create interest-based groups, and connect across campus communities.',
            frameworks: 'Docker, MySQL, Django, Python, Svelte',
            image: UniHub,
            githubLink: 'https://github.com/sudefidan/UniHub'
        },
        {
            title: 'Smart Pricing',
            description: 'Predictive pricing system built using statistical modelling on historical tooling data to estimate quotation prices with high accuracy and reduce pricing variance.',
            frameworks: 'R, Minitab, VBA'
        },
        {
            title: 'Workload Monitor',
            description: 'Manufacturing analytics application that collects, processes, and visualises production data to monitor workload and generate automated operational reports.',
            frameworks: 'C#, WPF, SQL Server, .NET'
        },
        {
            title: 'Players R Us',
            description: 'Football analytics web application that estimates player transfer values using team performance metrics and historical league match data.',
            frameworks: 'Python, Flask, PyMySQL, HTML, CSS',
            image: PlayersRUs
        },
        {
            title: 'Document Translator',
            description: 'Desktop application that translates documents using customisable glossaries stored in Google Cloud Storage, allowing teams to standardise terminology across translations. The system enables glossary management and ensures consistent domain-specific language in translated documents.',
            frameworks: 'JavaScript, Electron, Google Cloud Storage'
        },
        {
            title: 'Strawberry Farm',
            description: 'Agent-based simulation modelling autonomous farming agents performing tasks such as harvesting, navigation, and resource allocation in a virtual farm environment.',
            frameworks: 'Python, Mesa, Matplotlib',
            image: StrawberryFarm
        },
        {
            title: 'Horizon Cinemas',
            description: 'Cinema management system supporting ticket booking, scheduling, and role-based access for staff and customers across a multi-screen cinema chain.',
            frameworks: 'Python, Tkinter, SQLite3',
            image: HorizonCinemas,
            githubLink: 'https://github.com/sudefidan/HorizonCinemas'
        }
    ];

    const handleGitHubClick = () => {
        window.open("https://github.com/sudefidan", "_blank", "noopener,noreferrer");
    };

    return (
        <div className='container'>
            <div className="title-box text-center">
                <h1 className="title-a">Projects</h1>
                <div className="line-mf"></div>
            </div>
            <div className="projects-mf">
                {projectList.map((project, index) => (
                    <div className={`project-container ${project.large && project.image ? 'large' : ''} ${project.image ? 'has-image' : 'no-image'}`} key={index}>

                        {project.image ? (
                            <div className="project-img">
                                <img src={project.image} alt={project.title} className="img-fluid" />
                            </div>
                        ) : null}
                        <div className="project-content">
                            <h2 className="project-title">{project.title}</h2>
                            <div className="project-description">{project.description}</div>
                            <div className="project-description">{project.frameworks}</div>
                            <div className="project-description"></div>
                            {project.downloadLinks && (
                                <div className="projects-download-link">
                                    <a href={project.downloadLinks.apple} target="_blank" rel="noopener noreferrer">
                                        <img src={AppStoreIcon} alt="Download on the App Store" width={135} height={40} />
                                    </a>
                                    <a href={project.downloadLinks.android} target="_blank" rel="noopener noreferrer">
                                        <img src={GooglePlayStoreIcon} alt="Get it on Google Play" width={135} height={40} />
                                    </a>
                                </div>
                            )}
                            {project.githubLink && (
                                <a href={project.githubLink} target="_blank" rel="noopener noreferrer">
                                    <div className="projects-github">
                                        <FaGithub className='projects-github-icon' />
                                        View
                                    </div>
                                </a>
                            )}
                        </div>

                    </div>
                ))}
            </div>
            <div className="text-center">
                <button
                    type="button"
                    className="button button-a button-big button-rounded"
                    onClick={handleGitHubClick}
                >
                    Visit GitHub
                </button>
            </div>
        </div>
    );
};

export default Projects;